// lib
import moment from "moment";
import "moment/locale/fr";
import { momentLocalizer } from "react-big-calendar";
// src
import i18n from "i18n/proxy";
// configuration
moment.locale("fr", {
  weekdaysShort: ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"],
});

export const currentLocalizer = (language) => {
  moment.locale(language);
  // Impose Monday as the first day of the week for any culture, eases events cache refresh
  return { ...momentLocalizer(moment), startOfWeek: () => 1 };
};

export const formats = (language, isSmall) => {
  // fallback since it's tricky for specific Calendar Views to know it
  const l = language || i18n.language;
  const localizer = currentLocalizer(l);
  return {
    dayHeaderFormat: (date) => {
      if (l === "fr") return localizer.format(date, "ddd D MMM YYYY");
      return localizer.format(date, "ddd, MMM D YYYY");
    },
    // Week & month view: month header
    dayRangeHeaderFormat: ({ start, end }) => {
      const mStart = localizer.format(start, "MMMM");
      const mEnd = localizer.format(end, "MMMM");
      const yStart = localizer.format(start, "YYYY");
      const yEnd = localizer.format(end, "YYYY");
      if (mStart === mEnd) return `${mStart} ${yStart}`;
      if (yStart === yEnd) return `${mStart} - ${localizer.format(end, "MMM")} ${yStart}`;
      return `${localizer.format(start, "MMM")} ${yStart} - ${localizer.format(
        end,
        "MMM",
      )} ${yEnd}`;
    },
    eventTimeRangeFormat: ({ start, end }) =>
      `${localizer.format(start, "HH:mm")}-${localizer.format(end, "HH:mm")} `,
    // Week & month view: hours of the day on the left gutter
    timeGutterFormat: (date) =>
      isSmall ? localizer.format(date, "HH") : localizer.format(date, "HH:mm"),
  };
};

export const formatEndAccessor = (event) => {
  //If endHour equal 00:00 the component react calendar can't display the event on day and week view
  //So return if endHour equal 00:00, return 23:59
  return moment(event.end).format("HH:mm") === "00:00"
    ? new Date(event.end.getTime() - 1)
    : new Date(event.end);
};

export const messages = (language, isSmall) => {
  if (language === "fr") {
    return {
      allDay: "journée",
      today: isSmall ? "auj." : "aujourd'hui",
      month: "mois",
      week: "semaine",
      day: "jour",
      threeDays: "3 jours",
      fiveDays: "lundi-vendredi",
      timeline: "chronologie",
      agenda: "agenda",
      date: "date",
      time: "heure",
      event: "événement", // Or anything you want
      showMore: (total) => `+ ${total} événement(s) supplémentaire(s)`,
    };
  }
  return {
    allDay: "all day",
    today: isSmall ? "today" : "today",
    month: "month",
    week: "week",
    day: "day",
    threeDays: "3 days",
    fiveDays: "Monday-Friday",
    timeline: "timeline",
    agenda: "agenda",
    date: "date",
    time: "hour",
    event: "event", // Or anything you want
    showMore: (total) => `+ ${total} additional events(s)`,
  };
};
